declare namespace $ {

	type $shm_echarts__option_shm_wordstat_chart_timeseries_1 = $mol_type_enforce<
		ReturnType< $shm_wordstat_chart_timeseries['option'] >
		,
		ReturnType< $shm_echarts['option'] >
	>
	type $shm_echarts__brush_cursor_shm_wordstat_chart_timeseries_2 = $mol_type_enforce<
		ReturnType< $shm_wordstat_chart_timeseries['brush_cursor'] >
		,
		ReturnType< $shm_echarts['brush_cursor'] >
	>
	type $shm_echarts__click_shm_wordstat_chart_timeseries_3 = $mol_type_enforce<
		ReturnType< $shm_wordstat_chart_timeseries['point_click'] >
		,
		ReturnType< $shm_echarts['click'] >
	>
	type $shm_echarts__brush_end_shm_wordstat_chart_timeseries_4 = $mol_type_enforce<
		ReturnType< $shm_wordstat_chart_timeseries['brush_end'] >
		,
		ReturnType< $shm_echarts['brush_end'] >
	>
	type $shm_echarts__finished_shm_wordstat_chart_timeseries_5 = $mol_type_enforce<
		ReturnType< $shm_wordstat_chart_timeseries['rendered'] >
		,
		ReturnType< $shm_echarts['finished'] >
	>
	export class $shm_wordstat_chart_timeseries extends $mol_view {
		option( ): any
		brush_cursor( ): any
		point_click( next?: any ): any
		brush_end( next?: any ): any
		rendered( next?: any ): any
		Chart( ): $shm_echarts
		rows( ): readonly(any)[]
		title( ): string
		period_kind( ): string
		period_range_pick( next?: any ): any
		sub( ): readonly(any)[]
	}
	
}

//# sourceMappingURL=timeseries.view.tree.d.ts.map